<div class="sl-popover-backdrop"
     *ngIf="openConditionId || showSavedViews"
     (click)="closePopovers()" data-ui-name="Div" data-ui-component="record-filter-bar" data-testid="record-filter-bar-div"></div>

<!-- Reusable condition editor: field → range type → range values -->
<ng-template #conditionEditor let-condition>
  <div class="sl-popover-line">
    <select class="sl-popover-field"
            [ngModel]="condition.field"
            (ngModelChange)="setConditionField(condition, $event)"
            [attr.data-testid]="'sl-condition-field-' + condition.id" data-ui-name="Condition field" data-ui-component="record-filter-bar">
      <option [ngValue]="null" data-ui-name="Select a field… — condition field" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-a-field-condition-field">Select a field…</option>
      <option *ngFor="let field of fields" [ngValue]="field.id" data-ui-name="Field label — condition field" data-ui-component="record-filter-bar" data-testid="record-filter-bar-field-label-condition-field" [attr.data-entity-key]="field.id" data-entity-type="field">{{field.label}}</option>
    </select>
  </div>

  <div class="sl-popover-line" *ngIf="fieldOf(condition) && opsFor(condition).length > 1">
    <select class="sl-popover-op-select"
            [ngModel]="condition.op"
            (ngModelChange)="setConditionOp(condition, $event)"
            [attr.data-testid]="'sl-condition-op-' + condition.id" data-ui-name="Condition op" data-ui-component="record-filter-bar">
      <option [ngValue]="null" data-ui-name="Select a range type… — condition op" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-a-range-type-condition-op">Select a range type…</option>
      <option *ngFor="let op of opsFor(condition)" [ngValue]="op.id" data-ui-name="Op label — condition op" data-ui-component="record-filter-bar" data-testid="record-filter-bar-op-label-condition-op" [attr.data-entity-key]="op.id" data-entity-type="op">{{op.label}}</option>
    </select>
  </div>

  <ng-container *ngIf="fieldOf(condition) && condition.op">
    <ng-container [ngSwitch]="fieldOf(condition).type">

      <div class="sl-popover-line" *ngSwitchCase="'metric'">
        <ng-container *ngIf="conditionArgCount(condition) > 0">
          <input type="number"
                 [ngModel]="condition.value"
                 (ngModelChange)="setConditionValue(condition, $event)"
                 [attr.data-testid]="'sl-condition-value-' + condition.id"
                 placeholder="—"  data-ui-name="Condition value" data-ui-component="record-filter-bar" aria-label="—"/>
          <span class="sl-popover-unit">{{conditionUnit(condition)}}</span>
          <ng-container *ngIf="conditionArgCount(condition) === 2">
            <span class="sl-popover-and">and</span>
            <input type="number"
                   [ngModel]="condition.value2"
                   (ngModelChange)="setConditionValue2(condition, $event)"
                   [attr.data-testid]="'sl-condition-value2-' + condition.id"
                   placeholder="—"  data-ui-name="Condition value2" data-ui-component="record-filter-bar" aria-label="—"/>
            <span class="sl-popover-unit">{{conditionUnit(condition)}}</span>
          </ng-container>
        </ng-container>
      </div>

      <div class="sl-popover-line sl-popover-line-stack" *ngSwitchCase="'items'">
        <select multiple size="5"
                [ngModel]="condition.value || []"
                (ngModelChange)="setConditionList(condition, $event)"
                [attr.data-testid]="'sl-condition-items-' + condition.id" data-ui-name="Condition value || []" data-ui-component="record-filter-bar">
          <option *ngFor="let item of itemOptions" [ngValue]="item.id" data-ui-name="Item label — condition value || []" data-ui-component="record-filter-bar" data-testid="record-filter-bar-item-label-condition-value" [attr.data-entity-key]="item.id" data-entity-type="item">{{item.label}}</option>
        </select>
      </div>

      <div class="sl-popover-line" *ngSwitchCase="'flag'">
        <select [ngModel]="conditionFlagValue(condition)"
                (ngModelChange)="setConditionFlag(condition, $event)"
                [attr.data-testid]="'sl-condition-flag-' + condition.id" data-ui-name="Condition flag value(condition)" data-ui-component="record-filter-bar">
          <option value="" data-ui-name="Select… — condition Flag Value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-condition-flag-value-condition">Select…</option>
          <option value="yes" data-ui-name="Yes — condition Flag Value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-yes-condition-flag-value-condition">Yes</option>
          <option value="no" data-ui-name="No — condition Flag Value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-no-condition-flag-value-condition">No</option>
        </select>
      </div>

      <div class="sl-popover-line" [class.sl-popover-line-stack]="condition.op === 'isAnyOf'" *ngSwitchCase="'enum'">
        <ng-container *ngIf="conditionArgCount(condition) > 0">
          <select *ngIf="condition.op === 'isAnyOf'" multiple size="5"
                  [ngModel]="condition.value || []"
                  (ngModelChange)="setConditionList(condition, $event)"
                  [attr.data-testid]="'sl-condition-enum-' + condition.id" data-ui-name="Condition value || []" data-ui-component="record-filter-bar">
            <option *ngFor="let option of enumOptions(condition)" [ngValue]="option.value" data-ui-name="Option label — condition value || []" data-ui-component="record-filter-bar" data-testid="record-filter-bar-option-label-condition-value">{{option.label}}</option>
          </select>
          <select *ngIf="condition.op !== 'isAnyOf'" class="sl-popover-field"
                  [ngModel]="condition.value"
                  (ngModelChange)="setConditionValue(condition, $event)"
                  [attr.data-testid]="'sl-condition-enum-' + condition.id" data-ui-name="Condition value" data-ui-component="record-filter-bar">
            <option [ngValue]="null" data-ui-name="Select… — condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-condition-value">Select…</option>
            <option *ngFor="let option of enumOptions(condition)" [ngValue]="option.value" data-ui-name="Option label — condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-option-label-condition-value-option-label-condition-value">{{option.label}}</option>
          </select>
        </ng-container>
      </div>

      <div class="sl-popover-line" *ngSwitchCase="'text'">
        <input type="text" class="sl-popover-text" *ngIf="conditionArgCount(condition) > 0"
               [ngModel]="condition.value"
               (ngModelChange)="setConditionValue(condition, $event)"
               [attr.data-testid]="'sl-condition-text-' + condition.id"
               placeholder="Type to match…"  data-ui-name="Type to match…" data-ui-component="record-filter-bar" aria-label="Type to match…"/>
      </div>

      <div class="sl-popover-line" [class.sl-popover-line-stack]="conditionArgCount(condition) === 2" *ngSwitchCase="'date'">
        <ng-container *ngIf="conditionArgCount(condition) > 0">
          <input [type]="dateInputType(condition)" class="sl-popover-date"
                 [ngModel]="condition.value"
                 (ngModelChange)="setConditionValue(condition, $event)"
                 [attr.data-testid]="'sl-condition-date-' + condition.id"  data-ui-name="Condition value" data-ui-component="record-filter-bar"/>
          <ng-container *ngIf="conditionArgCount(condition) === 2">
            <span class="sl-popover-and">and</span>
            <input [type]="dateInputType(condition)" class="sl-popover-date"
                   [ngModel]="condition.value2"
                   (ngModelChange)="setConditionValue2(condition, $event)"
                   [attr.data-testid]="'sl-condition-date2-' + condition.id"  data-ui-name="Condition value2" data-ui-component="record-filter-bar"/>
          </ng-container>
        </ng-container>
      </div>

    </ng-container>
  </ng-container>

  <p class="sl-popover-hint" *ngIf="fieldOf(condition)?.hint">{{fieldOf(condition).hint}}</p>
  <button type="button" class="sl-popover-delete" (click)="removeCondition(condition)" data-ui-name="Delete filter" data-ui-component="record-filter-bar" data-testid="record-filter-bar-delete-filter">Delete filter</button>
</ng-template>

<!-- Chip row -->
<div class="sl-filter-row" [attr.data-testid]="testIdPrefix + '-content-filters'">
  <span class="sl-filter-row-label" *ngIf="rowLabel">{{rowLabel}}</span>

  <div class="sl-filter-chip-wrap" *ngFor="let condition of conditions">
    <span class="sl-filter-chip" [class.is-set]="isConditionActive(condition)">
      <button type="button"
              class="sl-chip-main"
              [attr.data-testid]="'sl-condition-chip-' + condition.id"
              (click)="toggleConditionEditor(condition.id)" data-ui-name="Toggle Condition Editor" data-ui-component="record-filter-bar" [attr.data-entity-key]="condition.id" data-entity-type="condition">
        <span class="sl-chip-label">{{conditionChipLabel(condition)}}</span>
        <span class="sl-chip-value">{{conditionChipValue(condition)}}</span>
      </button>
      <button type="button"
              class="sl-chip-remove"
              aria-label="Remove filter"
              (click)="removeCondition(condition)" data-ui-name="Remove filter" data-ui-component="record-filter-bar" data-testid="record-filter-bar-remove-filter" [attr.data-entity-key]="condition.id" data-entity-type="condition">&times;</button>
    </span>

    <div class="sl-filter-popover" *ngIf="openConditionId === condition.id">
      <div class="sl-popover-title">Filter</div>
      <ng-container *ngTemplateOutlet="conditionEditor; context:{$implicit: condition}"></ng-container>
    </div>
  </div>

  <button type="button"
          class="sl-filter-add"
          [attr.data-testid]="testIdPrefix + '-add-filter'"
          (click)="addCondition()" data-ui-name="Add Condition" data-ui-component="record-filter-bar">{{addLabel}}</button>

  <button type="button"
          class="sl-filter-advanced"
          [class.is-open]="isAdvancedFilter"
          [attr.data-testid]="testIdPrefix + '-advanced-toggle'"
          (click)="isAdvancedFilter = !isAdvancedFilter" data-ui-name="Advanced filter" data-ui-component="record-filter-bar">
    Advanced filter <span class="sl-chevron">{{isAdvancedFilter ? '▾' : '▸'}}</span>
  </button>

  <div class="sl-filter-chip-wrap" *ngIf="presetStore">
    <button type="button"
            class="sl-filter-advanced"
            [class.is-open]="showSavedViews"
            [attr.data-testid]="testIdPrefix + '-saved-views-toggle'"
            (click)="toggleSavedViews()" data-ui-name="Saved filters ▾" data-ui-component="record-filter-bar">
      Saved filters<span class="sl-saved-count" *ngIf="savedViews.length"> ({{savedViews.length}})</span>
      <span class="sl-chevron">▾</span>
    </button>

    <div class="sl-filter-popover sl-saved-popover" *ngIf="showSavedViews">
      <div class="sl-popover-title">Saved filters</div>

      <div class="sl-saved-view" *ngFor="let view of savedViews">
        <button type="button"
                class="sl-saved-apply"
                [attr.data-testid]="'sl-saved-view-' + view.id"
                (click)="applySavedView(view)" data-ui-name="Apply Saved View" data-ui-component="record-filter-bar" [attr.data-entity-key]="view.id" data-entity-type="view">
          <span class="sl-saved-name">{{view.name}}</span>
          <span class="sl-saved-desc">{{describeSavedView(view)}}</span>
        </button>
        <button type="button"
                class="sl-saved-delete"
                aria-label="Delete saved filter"
                (click)="deleteSavedView(view)" data-ui-name="Delete saved filter" data-ui-component="record-filter-bar" data-testid="record-filter-bar-delete-saved-filter" [attr.data-entity-key]="view.id" data-entity-type="view">&times;</button>
      </div>
      <div class="sl-popover-hint" *ngIf="!savedViews.length">Nothing saved yet.</div>

      <div class="sl-saved-new">
        <input type="text"
               [(ngModel)]="newViewName"
               placeholder="Name these filters…"
               [attr.data-testid]="testIdPrefix + '-save-view-name'"  data-ui-name="Name these filters…" data-ui-component="record-filter-bar" aria-label="Name these filters…"/>
        <button type="button"
                class="button is-small is-info"
                [disabled]="!canSaveCurrentView"
                [attr.data-testid]="testIdPrefix + '-save-view'"
                (click)="saveCurrentView()" data-ui-name="Save Current View" data-ui-component="record-filter-bar">{{saveWouldReplace ? 'Update' : 'Save'}}</button>
      </div>
      <p class="sl-popover-hint">{{saveHint}}<ng-container *ngIf="saveWouldReplace"> A filter with this name exists — saving replaces it.</ng-container></p>
    </div>
  </div>

  <button type="button"
          class="sl-filter-clear"
          [attr.data-testid]="testIdPrefix + '-clear-filters'"
          [disabled]="!hasActiveFilters"
          (click)="clearAllFilters()" data-ui-name="Clear" data-ui-component="record-filter-bar">Clear</button>

  <ng-content select="[slot=trailing]"></ng-content>
</div>

<p class="sl-saved-notice" *ngIf="notice" [attr.data-testid]="testIdPrefix + '-saved-notice'">{{notice}}</p>

<!-- Advanced panel -->
<div class="sl-advanced-filter" *ngIf="isAdvancedFilter" [attr.data-testid]="testIdPrefix + '-advanced-panel'">
  <div class="sl-advanced-row" *ngFor="let condition of conditions; let i = index">
    <span class="sl-advanced-conj" [ngSwitch]="advancedConjunction(i)">
      <span *ngSwitchCase="'where'">Where</span>
      <select *ngSwitchCase="'select'" [ngModel]="joinMode" (ngModelChange)="setJoinMode($event)" data-ui-name="Join mode" data-ui-component="record-filter-bar" data-testid="record-filter-bar-join-mode" [attr.data-entity-key]="condition.id" data-entity-type="condition">
        <option value="AND" data-ui-name="And — join Mode" data-ui-component="record-filter-bar" data-testid="record-filter-bar-and-join-mode" [attr.data-entity-key]="condition.id" data-entity-type="condition">And</option>
        <option value="OR" data-ui-name="Or — join Mode" data-ui-component="record-filter-bar" data-testid="record-filter-bar-or-join-mode" [attr.data-entity-key]="condition.id" data-entity-type="condition">Or</option>
      </select>
      <span *ngSwitchDefault>{{joinMode === 'OR' ? 'Or' : 'And'}}</span>
    </span>

    <select class="sl-advanced-select"
            [ngModel]="condition.field"
            (ngModelChange)="setConditionField(condition, $event)" data-ui-name="Condition field" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-field" [attr.data-entity-key]="condition.id" data-entity-type="condition">
      <option [ngValue]="null" data-ui-name="Select a field… — condition field" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-a-field-condition-field-select-a-field-condition-field" [attr.data-entity-key]="condition.id" data-entity-type="condition">Select a field…</option>
      <option *ngFor="let field of fields" [ngValue]="field.id" data-ui-name="Field label — condition field" data-ui-component="record-filter-bar" data-testid="record-filter-bar-field-label-condition-field-field-label-condition-field" [attr.data-entity-key]="field.id" data-entity-type="field">{{field.label}}</option>
    </select>

    <select class="sl-advanced-select"
            *ngIf="fieldOf(condition) && opsFor(condition).length > 1"
            [ngModel]="condition.op"
            (ngModelChange)="setConditionOp(condition, $event)" data-ui-name="Condition op" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-op" [attr.data-entity-key]="condition.id" data-entity-type="condition">
      <option [ngValue]="null" data-ui-name="Select a range type… — condition op" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-a-range-type-condition-op-select-a-range-type-condition-op" [attr.data-entity-key]="condition.id" data-entity-type="condition">Select a range type…</option>
      <option *ngFor="let op of opsFor(condition)" [ngValue]="op.id" data-ui-name="Op label — condition op" data-ui-component="record-filter-bar" data-testid="record-filter-bar-op-label-condition-op-op-label-condition-op" [attr.data-entity-key]="op.id" data-entity-type="op">{{op.label}}</option>
    </select>

    <ng-container *ngIf="fieldOf(condition) && condition.op">
      <ng-container [ngSwitch]="fieldOf(condition).type">

        <ng-container *ngSwitchCase="'metric'">
          <ng-container *ngIf="conditionArgCount(condition) > 0">
            <input type="number" class="sl-advanced-number"
                   [ngModel]="condition.value"
                   (ngModelChange)="setConditionValue(condition, $event)"
                   placeholder="—"  data-ui-name="Condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-value" aria-label="—" [attr.data-entity-key]="condition.id" data-entity-type="condition"/>
            <span class="sl-advanced-op">{{conditionUnit(condition)}}</span>
            <ng-container *ngIf="conditionArgCount(condition) === 2">
              <span class="sl-advanced-op">and</span>
              <input type="number" class="sl-advanced-number"
                     [ngModel]="condition.value2"
                     (ngModelChange)="setConditionValue2(condition, $event)"
                     placeholder="—"  data-ui-name="Condition value2" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-value2" aria-label="—" [attr.data-entity-key]="condition.id" data-entity-type="condition"/>
              <span class="sl-advanced-op">{{conditionUnit(condition)}}</span>
            </ng-container>
          </ng-container>
        </ng-container>

        <button type="button" class="sl-advanced-value" *ngSwitchCase="'items'"
                (click)="toggleConditionEditor(condition.id)" data-ui-name="Toggle Condition Editor" data-ui-component="record-filter-bar" data-testid="record-filter-bar-toggle-condition-editor" [attr.data-entity-key]="condition.id" data-entity-type="condition">{{conditionChipValue(condition)}}</button>

        <select class="sl-advanced-select" *ngSwitchCase="'flag'"
                [ngModel]="conditionFlagValue(condition)"
                (ngModelChange)="setConditionFlag(condition, $event)" data-ui-name="Condition flag value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-flag-value-condition" [attr.data-entity-key]="condition.id" data-entity-type="condition">
          <option value="" data-ui-name="Select… — condition Flag Value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-condition-flag-value-condition-select-condition-flag-value-condition" [attr.data-entity-key]="condition.id" data-entity-type="condition">Select…</option>
          <option value="yes" data-ui-name="Yes — condition Flag Value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-yes-condition-flag-value-condition-yes" [attr.data-entity-key]="condition.id" data-entity-type="condition">Yes</option>
          <option value="no" data-ui-name="No — condition Flag Value(condition)" data-ui-component="record-filter-bar" data-testid="record-filter-bar-no-condition-flag-value-condition-no" [attr.data-entity-key]="condition.id" data-entity-type="condition">No</option>
        </select>

        <ng-container *ngSwitchCase="'enum'">
          <button type="button" class="sl-advanced-value" *ngIf="condition.op === 'isAnyOf'"
                  (click)="toggleConditionEditor(condition.id)" data-ui-name="Toggle Condition Editor" data-ui-component="record-filter-bar" data-testid="record-filter-bar-toggle-condition-editor-daf8f2b" [attr.data-entity-key]="condition.id" data-entity-type="condition">{{conditionChipValue(condition)}}</button>
          <select class="sl-advanced-select" *ngIf="condition.op !== 'isAnyOf' && conditionArgCount(condition) > 0"
                  [ngModel]="condition.value"
                  (ngModelChange)="setConditionValue(condition, $event)" data-ui-name="Condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-value-f9f5e00" [attr.data-entity-key]="condition.id" data-entity-type="condition">
            <option [ngValue]="null" data-ui-name="Select… — condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-select-condition-value-select-condition-value" [attr.data-entity-key]="condition.id" data-entity-type="condition">Select…</option>
            <option *ngFor="let option of enumOptions(condition)" [ngValue]="option.value" data-ui-name="Option label — condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-option-label-condition-value-46514a81">{{option.label}}</option>
          </select>
        </ng-container>

        <input type="text" class="sl-advanced-text" *ngSwitchCase="'text'"
               [ngModel]="condition.value"
               (ngModelChange)="setConditionValue(condition, $event)"
               placeholder="Type to match…"  data-ui-name="Type to match…" data-ui-component="record-filter-bar" data-testid="record-filter-bar-type-to-match" aria-label="Type to match…" [attr.data-entity-key]="condition.id" data-entity-type="condition"/>

        <ng-container *ngSwitchCase="'date'">
          <ng-container *ngIf="conditionArgCount(condition) > 0">
            <input [type]="dateInputType(condition)" class="sl-advanced-date"
                   [ngModel]="condition.value"
                   (ngModelChange)="setConditionValue(condition, $event)"  data-ui-name="Condition value" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-value-fef97a0" [attr.data-entity-key]="condition.id" data-entity-type="condition"/>
            <ng-container *ngIf="conditionArgCount(condition) === 2">
              <span class="sl-advanced-op">and</span>
              <input [type]="dateInputType(condition)" class="sl-advanced-date"
                     [ngModel]="condition.value2"
                     (ngModelChange)="setConditionValue2(condition, $event)"  data-ui-name="Condition value2" data-ui-component="record-filter-bar" data-testid="record-filter-bar-condition-value2-0ce1acb" [attr.data-entity-key]="condition.id" data-entity-type="condition"/>
            </ng-container>
          </ng-container>
        </ng-container>

      </ng-container>
    </ng-container>

    <button type="button" class="sl-advanced-remove" (click)="removeCondition(condition)" data-ui-name="Remove Condition" data-ui-component="record-filter-bar" data-testid="record-filter-bar-remove-condition" [attr.data-entity-key]="condition.id" data-entity-type="condition">&times;</button>
  </div>

  <button type="button" class="sl-filter-add" (click)="addCondition()" data-ui-name="+ Add filter" data-ui-component="record-filter-bar" data-testid="record-filter-bar-add-filter">+ Add filter</button>

  <p class="sl-advanced-note">{{advancedNote}}</p>
</div>

<p *ngFor="let warning of inputWarnings()" role="alert" class="help is-danger" data-ui-name="Warning" data-ui-component="record-filter-bar" data-testid="record-filter-bar-warning">{{warning}}</p>
